import React, { useMemo } from "react";
import { TargetTypeEnum } from "../../../classes/enums/SppEnum";
import { SPINESIM_MODALITIES } from "../../../classes/enums/MedicalImagesEnum";
import SppWidget from "../../common/spp/SppWidget";
import "../../common/spp/SppWidget.css";
import ValidationFlag from "../../validation/validationFlag/ValidationFlag";

const AlignSpp = ({
  measurementConfigs,
  customMeasurementConfigs,
  onSppSelected,
  onSppSelectedCustom,
  activeParameters,
  removeCustomParameter,
  instances,
  refresh,
  selectedTargetType = TargetTypeEnum.GAP,
  onTargetTypeChange,
  originalMeasurements = {},
  currentMeasurements = {},
  targetMeasurements = {},
  digitalTwinId = null,
  initialKeyParameters = [],
  currentPlan = null,
  currentPlanId = null,
  latestMeasurementEvent = null,
  compareMode = false,
  currentPlanLabel = "Plan",
  comparedPlanLabel = "Plan",
  comparedCurrentMeasurements = {},
  isDisabled = false,
}) => {
  // This component is purely presentational.
  // Measurements are read directly from plan objects (DB is source of truth).
  // - currentMeasurements: from currentPlan.current_measurements
  // - targetMeasurements: from currentPlan.target_measurements
  // - comparedCurrentMeasurements: from comparedPlan.current_measurements
  // - originalMeasurements: from context (instance-level, shared across plans)

  const updateParamsWithValues = useMemo(
    () => params => {
      const actualCurrentValues =
        Object.keys(currentMeasurements).length > 0 ? currentMeasurements : {};

      const actualTargetValues =
        !compareMode && Object.keys(targetMeasurements).length > 0
          ? targetMeasurements
          : {};

      const actualComparedValues =
        compareMode && comparedCurrentMeasurements
          ? comparedCurrentMeasurements
          : {};

      return params.map(param => ({
        ...param,
        targetValue: compareMode
          ? undefined
          : actualTargetValues.hasOwnProperty(param.key)
            ? actualTargetValues[param.key]
            : undefined,
        currentValue: actualCurrentValues.hasOwnProperty(param.key)
          ? actualCurrentValues[param.key]
          : undefined,
        originalValue: originalMeasurements.hasOwnProperty(param.key)
          ? originalMeasurements[param.key]
          : undefined,
        comparedCurrentValue: actualComparedValues.hasOwnProperty(param.key)
          ? actualComparedValues[param.key]
          : undefined,
      }));
    },
    [
      compareMode,
      comparedCurrentMeasurements,
      currentMeasurements,
      originalMeasurements,
      targetMeasurements,
    ]
  );

  if (!measurementConfigs) {
    return (
      <div>
        <ValidationFlag modalityContext={SPINESIM_MODALITIES.DX} />
        <div>Loading measurements...</div>
      </div>
    );
  }

  return (
    <div className="App-spp-widget">
      <ValidationFlag
        instances={instances}
        refresh={refresh}
        modalityContext={SPINESIM_MODALITIES.DX}
        disabled={isDisabled}
      />
      <SppWidget
        isOctView={true}
        updateParamsWithValues={updateParamsWithValues}
        onSppSelected={onSppSelected}
        onSppSelectedCustom={onSppSelectedCustom}
        removeCustomParameter={removeCustomParameter}
        activeParameters={activeParameters}
        measurementConfigs={measurementConfigs}
        customMeasuramentConfigs={customMeasurementConfigs}
        selectedTargetType={selectedTargetType}
        onTargetTypeChange={onTargetTypeChange}
        showCoronalParameters={false}
        digitalTwinId={digitalTwinId}
        initialKeyParameters={initialKeyParameters}
        compareMode={compareMode}
        currentPlanLabel={currentPlanLabel}
        comparedPlanLabel={comparedPlanLabel}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default React.memo(AlignSpp);
